import { DownloadIcon, FileCodeIcon, FileIcon, FileTextIcon, FileType2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

import type { ContentBriefDownloadFormat } from './content-brief.interface'

export interface ContentBriefDownloadButtonProps {
  formatList: ContentBriefDownloadFormat[]
  onDownload: (format: ContentBriefDownloadFormat) => void
}

interface DownloadOption {
  format: ContentBriefDownloadFormat
  label: string
  icon: React.ElementType
}

const DOWNLOAD_OPTION_MAP: Record<ContentBriefDownloadFormat, DownloadOption> = {
  pdf: { format: 'pdf', label: 'PDF (.pdf)', icon: FileType2Icon },
  md: { format: 'md', label: 'Markdown (.md)', icon: FileTextIcon },
  txt: { format: 'txt', label: 'Plain Text (.txt)', icon: FileIcon },
  html: { format: 'html', label: 'HTML (.html)', icon: FileCodeIcon },
}

export const ContentBriefDownloadButton: React.FC<ContentBriefDownloadButtonProps> = ({
  formatList,
  onDownload,
}): ReactNode => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="outline" size="sm" className="content-brief-download-trigger">
        <DownloadIcon className="size-4" />
        Download
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" className="content-brief-download-menu">
      {formatList.map((format) => {
        const option = DOWNLOAD_OPTION_MAP[format]
        const IconComponent = option.icon
        return (
          <DropdownMenuItem
            key={option.format}
            onClick={() => onDownload(option.format)}
            className="content-brief-download-option"
          >
            <IconComponent className="size-4" />
            {option.label}
          </DropdownMenuItem>
        )
      })}
    </DropdownMenuContent>
  </DropdownMenu>
)
